import { gql, TypedDocumentNode } from '@apollo/client';

export type RequestReturnMutationVariables = {
  orderId: string;
  input: {
    data: {
      type: 'orders';
      id: string;
      action_type: 'request_return';
      attributes: {
        country_code: string;
        return_method_id: number;
        return_option_id: number;
        return_reason_hash: { [id: string]: string };
      };
    };
  };
};

export type RequestReturnMutation = {
  requestReturn: {
    __typename: 'RestRequestReturn';
    data: {
      __typename: 'RequestReturnData';
      attributes: { __typename: 'RequestReturnAttributes'; shipmentNumber: string };
    }[];
  };
};

export const REQUEST_RETURN_MUTATION: TypedDocumentNode<
  RequestReturnMutation,
  RequestReturnMutationVariables
> = gql`
  mutation RequestReturnMutation($orderId: String!, $input: RequestReturnMutationInput!) {
    requestReturn(orderId: $orderId, input: $input)
      @rest(
        type: "RestRequestReturn"
        endpoint: "moda"
        path: "/v3.5/orders/{args.orderId}"
        method: "PATCH"
      ) {
      data @type(name: "RequestReturnData") {
        attributes @type(name: "RequestReturnAttributes") {
          shipmentNumber: shipment_number
        }
      }
    }
  }
`;
